const ticketsLang = {

}

export default {
  tickets: ticketsLang
}
